import {Component,  ViewChild} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {ApiService} from '../../shared/services/api';
import {finalize} from 'rxjs';
import {LoaderService} from '../../shared/services/loader';
import {MatPaginator} from '@angular/material/paginator';
import {
  MatCell,
  MatCellDef, MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow, MatRowDef, MatTable, MatTableDataSource
} from '@angular/material/table';
import {Charger, ChargerResponse} from '../../shared/types/chargers.model';
import {MatIcon} from '@angular/material/icon';
import {MatIconButton} from '@angular/material/button';
import {MatSort, MatSortHeader} from '@angular/material/sort';
import {MatTab, MatTabGroup} from '@angular/material/tabs';
import {CommonModule} from '@angular/common';
import {MatFormField, MatLabel, MatPrefix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatDialog} from '@angular/material/dialog';
import {AddTariffPlanComponent} from '../add-tariff-plan/add-tariff-plan';

// Define interface for Tariff Plan
interface TariffPlan {
  tariffName: string;
  pricePerKwh: number;
  sgst: number;
  cgst: number;
  igst: number;
  assignedTo: string;
}

@Component({
  selector: 'app-chargers',
  imports: [
    CommonModule,
    MatPaginator,
    MatHeaderRowDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCell,
    MatCellDef,
    MatRow,
    MatHeaderRow,
    MatRowDef,
    MatColumnDef,
    MatTable,
    MatTab,
    MatTabGroup,
    MatIcon,
    MatIconButton,
    MatSort,
    MatSortHeader,
    MatFormField,
    MatInput,
    MatLabel,
    MatPrefix,
    RouterLink,
  ],
  templateUrl: './chargers.html',
  styleUrl: './chargers.css',
})
export class Chargers  {
  chargersDataSource = new MatTableDataSource<Charger>();
  tariffDataSource = new MatTableDataSource<TariffPlan>();
  selectedTabIndex = 0;

  @ViewChild(MatSort, { static: true })
  sort!: MatSort;

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  chargerDisplayedColumns = ["serialNumber", "model", "city","tariff","connectors","status","chargerOwner","actions"];
  tariffDisplayedColumns = ["tariffName", "pricePerKwh", "sgst", "cgst", "igst", "assignedTo", "actions"];

  // Mock data for tariff plans
  mockTariffData: TariffPlan[] = [
    { tariffName: 'TF_15/9/9/0', pricePerKwh: 18, sgst: 9, cgst: 9, igst: 18, assignedTo: '100' },
    { tariffName: 'TF_15/9/9/0.5', pricePerKwh: 25, sgst: 9, cgst: 9, igst: 18, assignedTo: '10' },
    { tariffName: 'TF_15/9/9/0.6', pricePerKwh: 15, sgst: 9, cgst: 9, igst: 18, assignedTo: '50' },
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private loader: LoaderService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.chargersDataSource.sort = this.sort;
    this.tariffDataSource.sort = this.sort;
    this.tariffDataSource.data = this.mockTariffData;

    this.loader.start();
    this.apiService
      .getChargers()
      .pipe(
        finalize(() => this.loader.stop())
      )
      .subscribe({
        next: (res: ChargerResponse) => {
          this.chargersDataSource.data = res.data;
          this.chargersDataSource.sort = this.sort;
          // Connect paginator after data is loaded
          if (this.paginator) {
            this.chargersDataSource.paginator = this.paginator;
          }
        },
        error: (err) => {
          console.error('Failed to get chargers', err);
        }
      });
  }

  ngAfterViewInit() {
    // Connect paginator to the active data source based on selected tab
    if (this.paginator) {
      this.updatePaginator();
    }
  }

  updatePaginator() {
    if (this.selectedTabIndex === 0) {
      this.chargersDataSource.paginator = this.paginator;
      this.tariffDataSource.paginator = null;
    } else if (this.selectedTabIndex === 1) {
      this.tariffDataSource.paginator = this.paginator;
      this.chargersDataSource.paginator = null;
    }
  }

  onTabChange(index: number) {
    this.selectedTabIndex = index;
    // Use setTimeout to ensure the view is updated before connecting paginator
    setTimeout(() => {
      this.updatePaginator();
    });
  }

  get currentDataLength(): number {
    if (this.selectedTabIndex === 0) {
      return this.chargersDataSource.data.length;
    } else if (this.selectedTabIndex === 1) {
      return this.tariffDataSource.data.length;
    }
    return 0;
  }

  openAddTariffDialog(): void {
    const dialogRef = this.dialog.open(AddTariffPlanComponent, {
      width: '600px',
      disableClose: false,
      panelClass: 'custom-dialog-container'
    });
  }

  addCharger() {
    this.router.navigate(['../add-charger'], {
      relativeTo: this.route,
    }).then(()=>{
      console.log("Navigate to User details Page");
    });
  }
  viewChargerInfo() {
    this.router.navigate(['../charger-info'], {
      relativeTo: this.route,
    }).then(()=>{
      console.log("Navigate to User details Page");
    })
  }
}
